<template>
    <div id="record">
        <div class="title">核销记录</div>
        <div class="main" v-loading="lookLoading">
            <!-- <div class="main-background"> -->
                <div class="query-form">
                    <el-row>
                        <el-form :model="formInline" ref="ruleForm" label-width="82px">
                            <el-form-item label="核销码：">
                                <el-input v-model="formInline.used_code" placeholder="请输入核销码"></el-input>
                            </el-form-item>
                            <el-form-item label="核销时间：" class="select-record">
                                <el-date-picker
                                    v-model="formInline.times"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label-width="0" class="form-item-button">
                                <el-button @click="resetForm('ruleForm')">重置</el-button>
                                <el-button type="primary" @click="query">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>
                <!-- <div style="height: 10px;background: #f0f0f0;"></div> -->
                <el-card class="table">
                    <el-table :data="tableData" style="width: 100%;min-height: 400px;" v-loading="loading">
                        <el-table-column prop="used_code" label="电子码"></el-table-column>
                        <el-table-column prop="sku_name" label="套餐规格"></el-table-column>
                        <el-table-column prop="nicknames" label="核销员"></el-table-column>
                        <el-table-column prop="name" label="门店名称"></el-table-column>
                        <el-table-column prop="time_used" label="核销时间"></el-table-column>
                        <el-table-column fixed="right" label="操作">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="lookDetails(scope.row)">查看详情</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="table-footer">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                        </el-pagination>
                    </div>
                </el-card>
            <!-- </div> -->
        </div>
        <el-dialog
            title="查看详情"
            :visible.sync="detailsDialog"
            width="50%">
            <div class="dialog-details">
                <div class="subtitle">
                    <h4>基本信息</h4>
                </div>
                <el-form label-width="100px" style="margin-top: 24px;">
                    <el-form-item label="核销信息：">
                        <span>{{ lookForm.used_code }}</span>
                    </el-form-item>
                    <el-form-item label="核销员：">
                        <span>{{ lookForm.admin_name }}</span>
                    </el-form-item>
                    <el-form-item label="核销景区：">
                        <span>{{ lookForm.shop_name }}</span>
                    </el-form-item>
                    <el-form-item label="核销时间：">
                        <span>{{ lookForm.time_used }}</span>
                    </el-form-item>
                </el-form>
                <div class="subtitle">
                    <h4>基本信息</h4>
                </div>
                <el-form label-width="100px" style="margin-top: 24px;">
                    <el-form-item label="景区封面：">
                         <el-image
                            style="width: 100px; height: 100px"
                            :src="lookForm.image_main"
                            :preview-src-list="lookForm.image_main.split()"
                            fit="fill"
                        ></el-image>
                    </el-form-item>
                    <el-form-item label="门票名称：">
                        <span>{{ lookForm.name }}</span>
                    </el-form-item>
                    <el-form-item label="门票规格：">
                        <span>{{ lookForm.sku_name }}</span>
                    </el-form-item>
                    <el-form-item label="会员名称：">
                        <span>{{ lookForm.user_name }}</span>
                    </el-form-item>
                    <el-form-item label="身份证号：">
                        <span>{{ lookForm.card_no }}</span>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getWriteOffList, getWriteOffDetail } from '@/api/baby/writeoff.js';
import { computeTime } from '@/utils/computing-time.js'
export default {
    data () {
        return {
            loading: false,
            lookLoading: false,
            formInline: {
                used_code: '',
                times: ''
            },
            data: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            check: 1,
            detailsDialog: false,
            lookForm: {
                shop_name: '',      //景区名
                used_code: '',      //核销编码
                image_main: '',     //景区封面
                sku_name: '',       //门票规格
                name: '',           //门票名称
                user_card_list: [], 
                order_status: '',   //核销状态 '状态 1-未支付 2-已支付，待三方对接 3-已对接，待使用 4-已使用，待评价 5-已取消 6-已完成 7-关闭',
                time_used: '',      //核销时间
                card_no: '',        //身份证号
                user_name: '',      //会员名
                admin_name: ''      //核销员
            }
        }
    }, 
    computed: {
        tableData () {
            return this.data
        }
    },
    methods: {
        handleSizeChange (page) {
            this.pageSize = page;
            this.initTable();
        },
        handleCurrentChange (page) {
            this.currentPage = page;
            this.initTable();
        },
        lookDetails (row) {
            this.lookLoading = true;
            let params = {
                used_code: row.used_code,
                card_no: row.card_no
            }
            getWriteOffDetail(params)
                .then(res => {
                    if (res.data.code == 0) {
                        if (res.data.data.length) {
                            this.lookForm = res.data.data[0];
                        }
                        this.detailsDialog = true;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.lookLoading = false;
                })
        },
        resetForm(formName) {
            this.formInline.used_code = '';
            this.formInline.times = '';
            this.initTable();
            // this.$refs[formName].resetFields();
        },
        query () {
            this.currentPage = 1;
            this.initTable();
        },
        initTable () {
            let params = {
                shop_id: JSON.parse(sessionStorage.getItem('userid'))*1 || 0,
                used_code: this.formInline.used_code,
                page_no: this.currentPage,
                page_size: this.pageSize
            }
            if (this.formInline.times) {
                params.start_time = computeTime(this.formInline.times[0]);
                params.end_time = computeTime(this.formInline.times[1]);
            }
            this.loading = true;
            getWriteOffList(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = res.data.data.list;
                        this.total = res.data.data.count;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        }
    },
    created () {
        this.initTable();
    }
}
</script>

<style lang="scss" scoped>
    #record {
        width: 100%;
        height: 100%;
        min-width: 1200px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        .title {
            box-shadow: 0px 0px 8px 0px rgba(100, 100,100, .17);
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
        }

        .main {
            background: rgb(240, 240, 240);
            .main-background {
                height: 100%;
                margin: 24px;
                background: #fff;
            }
        }
        .query-form {
            background-color: #fff;
            margin: 24px 24px 12px 24px;
            .el-form {
                padding: 24px 12px 10px 12px;
                display: flex;
                justify-content: space-between;
            }
        }
        .table {
            margin: 0px 24px 24px 24px;
        }
    }

    .table-footer {
        padding-right: 12px;
        display: flex;
        justify-content: flex-end;
    }

    ::v-deep .el-pagination {
        margin-top: 12px;
        display: inline-block;
    }

    ::v-deep .el-card__body {
        display: flex;
        flex-direction: column;
    }

    .dialog-details {
        padding: 24px;
        .subtitle {
            display: flex;
            align-items: center;
            &:first-child {
                margin-top: 0;
            }
            h4 {
                padding-left: 20px;
                line-height: 18px;
                position: relative;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 5px;
                background: #2448ff;
                }
            }
        }
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-select {
        width: 100%;
    }

    ::v-deep .el-range-separator {
        padding: 0;
    }

    ::v-deep .el-form-item {
        flex: 1;
        &:not(:first-child) {
            margin-left: 24px;
        }
    }
    
    .form-item-button {
        display: flex;
        justify-content: flex-start;
        margin-left: 12px;
    }
</style>